import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEthnicityService } from './../../Services/ethnicityService'

export const reducerName = 'ethnicity';

const initialState = {
  request: false,
  error: null,
  data: null
};

export const getEthnicity = createAsyncThunk(
  'ethnicity/get',
  async (a, { rejectWithValue }) => {
    try {
      
      const response = await getEthnicityService();

      return {
        data: response
      };
    } catch (error) {
      return rejectWithValue({
        error: error.message
      })
    }
  }
);


export const ethnicityReducer = createSlice({
  name: reducerName,
  initialState,
  extraReducers: (builder) => {

    builder.addCase(getEthnicity.fulfilled, (state, action) => {
      state.data = action.payload?.data;
      state.request = false;
    })

    builder.addCase(getEthnicity.rejected, (state, action) => {
      state.error = action.payload.error;
      state.request = false;
      state.data = null;
    })

    builder.addCase(getEthnicity.pending, (state) => {
      state.request = true;
      state.error = null;
      state.data = null;
    })
  }
});

export default ethnicityReducer.reducer;
